<rt-dialog-header [heading]="'rti.hotelprofessionals.name' | translate">
  {{ 'rti.hotelprofessionals.create_posting.modal.subtitle' | translate }}
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rti-hotelprofessionals-posting-form
    [postingForm]="postingForm"
    [errorFields]="state.errorFields"
  />
  <rti-error-messages-wrapper [errors]="state.errors" />
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button
    variant="primary"
    [disabled]="!formValid"
    [loading]="state.creating"
    (click)="publish()"
  >
    {{ 'rti.common.submit' | translate }}
  </rt-button>
</rt-dialog-footer>
